// Utils y constantes del form de Cliente - Sprint 32.

// Paises ISO 3166 - seleccion comun para comercio.
// Colombia primero para UX (usuario principal es CO).
export const PAISES = [
  { code: 'CO', name: 'Colombia',     default_iva: 19 },
  { code: 'US', name: 'Estados Unidos', default_iva: 0 },
  { code: 'MX', name: 'Mexico',       default_iva: 16 },
  { code: 'AR', name: 'Argentina',    default_iva: 21 },
  { code: 'CL', name: 'Chile',        default_iva: 19 },
  { code: 'PE', name: 'Peru',         default_iva: 18 },
  { code: 'EC', name: 'Ecuador',      default_iva: 12 },
  { code: 'PA', name: 'Panama',       default_iva: 7 },
  { code: 'VE', name: 'Venezuela',    default_iva: 16 },
  { code: 'BR', name: 'Brasil',       default_iva: 17 },
  { code: 'ES', name: 'Espana',       default_iva: 21 },
  { code: 'CN', name: 'China',        default_iva: 13 },
  { code: 'DE', name: 'Alemania',     default_iva: 19 },
  { code: 'GB', name: 'Reino Unido',  default_iva: 20 },
];

export const MONEDAS = ['COP', 'USD', 'EUR', 'CNY', 'MXN', 'ARS', 'CLP'];

export const LISTAS_PRECIOS = [
  { value: 'general',   label: 'General' },
  { value: 'mayorista', label: 'Mayorista' },
  { value: 'distribuidor', label: 'Distribuidor' },
  { value: 'vip',       label: 'VIP' },
];

export const TIPO_CLIENTE = [
  { value: 'contado', label: 'Contado' },
  { value: 'credito', label: 'Credito' },
];

export const TIPO_DESCUENTO = [
  { value: '',       label: 'Ninguno' },
  { value: 'pct',    label: 'Porcentaje (%)' },
  { value: 'monto',  label: 'Monto fijo' },
];

// --- Colombia fiscal ---
export const TIPO_DOCUMENTO_CO = [
  { value: 'CC',  label: 'Cedula de ciudadania' },
  { value: 'NIT', label: 'NIT' },
  { value: 'CE',  label: 'Cedula de extranjeria' },
  { value: 'TI',  label: 'Tarjeta de identidad' },
  { value: 'PA',  label: 'Pasaporte' },
];

export const TIPO_ORGANIZACION_CO = [
  { value: 'natural',  label: 'Persona natural' },
  { value: 'juridica', label: 'Persona juridica' },
];

export const REGIMEN_FISCAL_CO = [
  { value: 'responsable_iva',    label: 'Responsable de IVA' },
  { value: 'no_responsable_iva', label: 'No responsable de IVA' },
  { value: 'simple',             label: 'Regimen simple' },
];

export const TABS = ['datos', 'comercial', 'impuestos', 'fiscal_co', 'retenciones_co'];
export const TAB_LABELS = {
  datos: 'Datos cliente',
  comercial: 'Configuracion comercial',
  impuestos: 'Impuestos',
  fiscal_co: 'Factura electronica (Colombia)',
  retenciones_co: 'Retenciones (Colombia)',
};

export const EMPTY = {
  id: null,
  nombre: '',
  email: '',
  telefono: '',
  pais: 'Colombia',
  region: '',
  ciudad: '',
  direccion: '',
  moneda_preferida: 'COP',
  vendedor_id: null,
  lista_precios: 'general',
  tipo_cliente: 'contado',
  dias_credito: 0,
  limite_credito: 0,
  tipo_descuento: '',
  notas_pago: '',
  aplicar_impuesto: true,
  tasa_impuesto: 19,
  nit: '',
  dv: '',
  tipo_documento: 'CC',
  tipo_organizacion: 'natural',
  regimen_fiscal: 'no_responsable_iva',
  responsabilidad_fiscal: '',
  codigo_dane_municipio: '',
  codigo_dane_departamento: '',
  codigo_postal: '',
  retencion_fuente: false,
  retencion_iva: false,
  retencion_ica: false,
  autorretencion: false,
  is_active: true,
};

export function esColombia(pais) {
  if (!pais) return false;
  return String(pais).toLowerCase() === 'colombia';
}

export function ivaDefault(pais) {
  const p = PAISES.find((x) => x.name === pais);
  return p ? p.default_iva : 0;
}
